
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiCalendar } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // INSIGHTS_ENABLED: Set to true to show Insights in navigation
  const INSIGHTS_ENABLED = false;

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'About', href: '/about' },
    { name: 'Jobs', href: '/jobs' },
    { name: 'Careers', href: '/careers' },
    { name: 'For Candidates', href: '/candidates' },
    // Conditionally include Insights
    ...(INSIGHTS_ENABLED ? [{ name: 'Insights', href: '/insights' }] : []),
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753184531053-Untitled.png"
              alt="Trbe Logo"
              className="h-8"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-brand-orange border-b-2 border-brand-orange'
                    : 'text-gray-600 hover:text-brand-orange'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link
              to="/contact"
              className="bg-brand-orange text-white px-6 py-2 rounded-lg text-sm font-semibold hover:bg-opacity-90 transition-colors duration-200 flex items-center space-x-2"
            >
              <SafeIcon icon={FiCalendar} className="h-4 w-4" />
              <span>Book a Call</span>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-600 hover:text-brand-orange"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="md:hidden bg-white border-t border-gray-100"
        >
          <div className="px-4 py-2 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-3 py-2 rounded-lg text-base font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-brand-orange bg-gray-50'
                    : 'text-gray-600 hover:text-brand-orange hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className="block w-full text-center bg-brand-orange text-white px-3 py-3 rounded-lg text-base font-semibold hover:bg-opacity-90 transition-colors duration-200 mt-4 flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiCalendar} className="h-4 w-4" />
              <span>Book a Call</span>
            </Link>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header;
